import React, { useEffect } from 'react';
import CustompiechartCustomer from './CustompiechartCustomer';
import { useDispatch, useSelector } from 'react-redux';
import {settheexternalescalation_dashboardsactions}  from "../../../../../Redux/Slice"
import CustomerLevelPie from './CustomerLevelPie';


const CustomedashboardPie = ({
     datas,
        date,
        status,
        priority,
        client
}) => {
  const dispatch = useDispatch()
  const state = useSelector((state )=>state)

  const responseData = state.ExternalEscalationsdashboard.ExterenalEscalation_dashboard_?.closed_data
  const responseDataOpen = state.ExternalEscalationsdashboard.ExterenalEscalation_dashboard_?.opened_data

  const pieChartData = [
    {
      id: 0,
      value: responseData?.L1_closed_count || 0,
      label: 'L1 Count',
      color: 'rgb(46, 199, 109)',
    },
    {
      id: 1,
      value: responseData?.L2_closed_count || 0,
      label: 'L2 Count',
      color: 'rgb(255, 197, 0)',
    },
    {
      id: 2,
      value: responseData?.L3_closed_count || 0,
      label: 'L3 Count',
      color: 'rgb(255, 149, 56)',
    },
 
  ];

  const pieChartData_Inprogress = [
    {
      id: 0,
      value: responseDataOpen?.L1_opened_count || 0,
      label: 'L1 Count',
      color: 'rgb(46, 199, 109)',
    },
    {
      id: 1,
      value: responseDataOpen?.L2_opened_count || 0,
      label: 'L2 Count',
      color: 'rgb(255, 197, 0)',
    },
    {
      id: 2,
      value: responseDataOpen?.L3_opened_count || 0,
      label: 'L3  Count',
      color: 'rgb(255, 149, 56)',
    },
 
  ];

  useEffect(()=>{
            if(state.ClientBranchIDs.SUBROLE == 3){

    const payload ={
                state: datas.state,
                region: datas.region,
                zone: datas.zone,
                client:client,
                date:date,
                priority:priority,
                }
    dispatch(settheexternalescalation_dashboardsactions(payload))
              }
    },[datas  ,client  ,priority , date, ])
  
  return (
    <div style={{ display: 'flex',flexDirection:"column" }}>
      <div style={{ display: 'flex',flexDirection:"row" , width:"100%"}}>
    <h3 style={{display:"flex", justifyContent:"flex-start", width:"50%"}}>{"Resolutions by Escalation Stage"}</h3>
    <h3 style={{display:"flex", justifyContent:"flex-start" , width:"50%"}}>{"Pending Tickets by Escalation Stage"}</h3>
</div>
      <div style={{ display: 'flex',flexDirection:"row",justifyContent:"space-between" }}>

<div className='col-6'>
          <CustompiechartCustomer data={pieChartData} level={"Escalation Level Matrix"}/>

</div>
<div className='col-6'>

                <CustomerLevelPie data={pieChartData_Inprogress} level={"Escalation Level Matrix"}/>
</div>

</div>
    </div>
  );
};

export default CustomedashboardPie;
